import GrowthIcon from '@/components/DesignSystem/Icons/svgs/GrowthIcon';
import React from 'react';

interface StatItemProps {
  icon?: React.ReactNode;
  label: string;
  value: string;
  iconBackgroundColor?: string;
}

const StatItem: React.FC<StatItemProps> = ({
  icon,
  label,
  value,
  iconBackgroundColor = 'bg-primary-50',
}) => {
  return (
    <div className='flex flex-row w-full gap-4'>
      <GrowthIcon />
      <div className='flex flex-col min-w-0 flex-1'>
        <span className='font-body-14 text-gray-600'>{label}</span>
        <span className='font-body-14 font-bold break-words'>{value}</span>
      </div>
    </div>
  );
};

export default StatItem;
